import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"mb-5"},[_c(VCardTitle,[_vm._v("Statistiques saisonnières")]),_c(VCardText,[_c(VDataTable,{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.stats,"dense":"","hide-default-footer":"","disable-pagination":"","mobile-breakpoint":0}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }